import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=c8faf25c&scoped=true&"
import script from "./photoAlbum.vue?vue&type=script&lang=js&"
export * from "./photoAlbum.vue?vue&type=script&lang=js&"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=c8faf25c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8faf25c",
  null
  
)

export default component.exports